import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { FC } from 'react'
import React from 'react'
import styled from 'styled-components'

import TooltipIcon from './IconGroup/TooltipIcon'

interface Props {
  icon: IconDefinition
  tooltipMessage: string
  onClick: () => void
  disabled?: boolean
}

const ControlButtonContainer = styled.div<{ disabled?: boolean }>`
  cursor: pointer;
  color: ${props => (props.disabled ? '#a9a9a9' : '#34bebd')};
`

const ControlButton: FC<Props> = ({ icon, tooltipMessage, onClick, disabled }) => (
  <TooltipIcon
    icon={
      <ControlButtonContainer disabled={disabled}>
        <FontAwesomeIcon size="2x" icon={icon} onClick={onClick} />
      </ControlButtonContainer>
    }
    tooltipMessage={tooltipMessage}
  />
)

export default ControlButton
